import React, { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { createLocalAudioTrack, createLocalVideoTrack } from "twilio-video";
import { useSelector } from "react-redux";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import { getTwilioTrackNames } from "./twilioTrackNames";

function AvailableResources({ room, onResourceChange, value, onClose,micOnOff,videoOnOff }) {
  const { role } = useSelector((state) => state.user);
  const trackNames = getTwilioTrackNames(role);
  const [audioInputs, setAudioInputs] = useState([]);
  const [videoInputs, setVideoInputs] = useState([]);
  const [audioOutputs, setAudioOutputs] = useState([]);

  const [audioInputChange, setAudioInputChange] = useState(false);
  const [videoInputChange, setVideoInputChange] = useState(false);
  const [audioOutputChange, setAudioOutputChange] = useState(false);

  const [selectedAudioInput, setSelectedAudioInput] = useState(
    localStorage.getItem("selectedAudioInput") || ""
  );
  const [selectedVideoInput, setSelectedVideoInput] = useState(
    localStorage.getItem("selectedVideoInput") || ""
  );
  const [selectedAudioOutput, setSelectedAudioOutput] = useState(
    localStorage.getItem("selectedAudioOutput") || ""
  );
  const [isApplyChanges, setIsApplyChanges] = useState(false);
  const [isApplyChangesVideo, setIsApplyChangesVideo] = useState(false);
  const [isApplyChangesAudioOutput, setIsApplyChangesAudioOutput] =
    useState(false);
  useEffect(() => {
    const fetchAndSetDevices = async () => {
      const deviceInfos = await navigator.mediaDevices.enumerateDevices();
      const audioInputDevices = deviceInfos.filter(
        (device) => device.kind === "audioinput"
      );

      setAudioInputs(audioInputDevices);

      if (!selectedAudioInput && audioInputDevices.length > 0) {
        setSelectedAudioInput(audioInputDevices[0].deviceId);
        localStorage.setItem(
          "selectedAudioInput",
          audioInputDevices[0].deviceId
        );
      }
    };

    fetchAndSetDevices();
  }, [selectedAudioInput]);

  useEffect(() => {
    const fetchAndSetVideo = async () => {
      const deviceInfos = await navigator.mediaDevices.enumerateDevices();

      const videoInputDevices = deviceInfos.filter(
        (device) => device.kind === "videoinput"
      );

      setVideoInputs(videoInputDevices);

      if (!selectedVideoInput && videoInputDevices.length > 0) {
        setSelectedVideoInput(videoInputDevices[0].deviceId);
        localStorage.setItem(
          "selectedVideoInput",
          videoInputDevices[0].deviceId
        );
      }
    };

    fetchAndSetVideo();
  }, [selectedVideoInput]);

  useEffect(() => {
    const fetchAndSetAudioOutput = async () => {
      const deviceInfos = await navigator.mediaDevices.enumerateDevices();

      const audioOutputDevices = deviceInfos.filter(
        (device) => device.kind === "audiooutput"
      );

      setAudioOutputs(audioOutputDevices);

      if (!selectedAudioOutput && audioOutputDevices.length > 0) {
        setSelectedAudioOutput(audioOutputDevices[0].deviceId);
        localStorage.setItem(
          "selectedAudioOutput",
          audioOutputDevices[0].deviceId
        );
      }
    };

    fetchAndSetAudioOutput();
  }, [selectedAudioOutput]);

  // Utility function to change audio output
  const setAudioOutputDevice = async (audioElement, deviceId) => {
    if (audioElement && audioElement.setSinkId) {
      try {
        await audioElement.setSinkId(deviceId);
        console.log(`Audio output device was changed to ${deviceId}`);
      } catch (error) {
        console.error("Failed to set audio output device:", error);
      }
    } else {
      console.warn(
        "Browser does not support output device selection or audioElement not found."
      );
    }
  };

  const switchAudioInput = async () => {
    setIsApplyChanges(true);
    const localParticipant = room.localParticipant;
    localParticipant.tracks.forEach((publication) => {
      console.log(publication.kind);
      if (publication.kind == "audio") {
        publication.track.stop();
        localParticipant.unpublishTrack(publication.track);
      }
    });
    try {
      const audioTrack = await createLocalAudioTrack({
        deviceId: { exact: selectedAudioInput },
        name: trackNames.microphone,
      });

      await Promise.all([
        localParticipant.publishTrack(audioTrack, { name: trackNames.microphone }),
      ]);

      localStorage.setItem("selectedAudioInput", selectedAudioInput);

      // Assuming you have an audio or video element with the id "mediaElement"
setAudioInputChange(false)
      setIsApplyChanges(false);
    } catch (error) {
      console.error("Error changing media devices:", error);
      setIsApplyChanges(false);
    }
  };
  const switchVideoInput = async () => {
    setIsApplyChangesVideo(true);
    const localParticipant = room.localParticipant;
    localParticipant.tracks.forEach((publication) => {
      if (publication.kind == "video") {
        publication.track.stop();
        localParticipant.unpublishTrack(publication.track);
      }
    });
    try {
      const videoTrack = await createLocalVideoTrack({
        deviceId: { exact: selectedVideoInput },
        name: trackNames.camera,
      });
      await Promise.all([
        localParticipant.publishTrack(videoTrack, { name: trackNames.camera }),
      ]);

      localStorage.setItem("selectedVideoInput", selectedVideoInput);
setVideoInputChange(false)
      onResourceChange(localParticipant.videoTracks); // Update any necessary state or props
      setIsApplyChangesVideo(false);
    } catch (error) {
      console.error("Error changing media devices:", error);
      setIsApplyChangesVideo(false);
    }
  };

  const switchAudioOutput = async () => {
    setIsApplyChangesAudioOutput(true);

    try {
      setAudioOutputChange(false)
      localStorage.setItem("selectedAudioOutput", selectedAudioOutput);

      // Assuming you have an audio or video element with the id "mediaElement"
      const mediaElement = document.getElementById("mediaElement");
      await setAudioOutputDevice(mediaElement, selectedAudioOutput);

      setIsApplyChangesAudioOutput(false);
    } catch (error) {
      console.error("Error changing media devices:", error);
      setIsApplyChangesAudioOutput(false);
    }
  };
  return (
    <Modal show={value} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Select Media Devices</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label
              style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Audio Input</span>{" "}
              {audioInputChange && (
              <>  <button
              style={{
                border: "none",
                padding: "2px",
                paddingLeft: "5px",
                paddingRight: "5px",
                color: "white",
                background: "green",
                borderRadius: "12px",
              }}
              onClick={(e) => {
                e.preventDefault();
                switchAudioInput();
              }}>
              {isApplyChanges ? "Saving..." : "Save"}
            
            </button>
            </>
              )}
            {!micOnOff &&   <span className="fs-7" style={{color:'red'}}>  Turn mic on to  change audio settings</span>}
            </Form.Label>

            <Form.Control
              as="select"
              value={selectedAudioInput}
              disabled={!micOnOff}
              onChange={(e) => {
                setAudioInputChange(true);
                setSelectedAudioInput(e.target.value);
              }}>
              {audioInputs.map((device) => (
                <option key={device.deviceId} value={device.deviceId}>
                  {device.label || device.deviceId}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label
              style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Video Input</span>{" "}
              {videoInputChange && (
                <button
                  style={{
                    border: "none",
                    padding: "2px",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    color: "white",
                    background: "green",
                    borderRadius: "12px",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    switchVideoInput();
                  }}>
                  {isApplyChangesVideo ? "Saving..." : "Save"}
                </button>
              )}
              {!videoOnOff &&   <span className="fs-7" style={{color:'red'}}>  Turn video on to  change video settings</span>}
            </Form.Label>
            <Form.Control
              as="select"
              disabled={!videoOnOff}
              value={selectedVideoInput}
              onChange={(e) => {
                setVideoInputChange(true);
                setSelectedVideoInput(e.target.value);
              }}>
              {videoInputs.map((device) => (
                <option key={device.deviceId} value={device.deviceId}>
                  {device.label || device.deviceId}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label
              style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Audio Output (Speakers)</span>{" "}
              {audioOutputChange && (
                <button
                  style={{
                    border: "none",
                    padding: "2px",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    color: "white",
                    background: "green",
                    borderRadius: "12px",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    switchAudioOutput();
                  }}>
                  {isApplyChangesAudioOutput ? "Saving..." : "Save"}
                </button>
              )}
            </Form.Label>

            <Form.Control
              as="select"
              value={selectedAudioOutput}
              onChange={(e) => {
                setAudioOutputChange(true);
                setSelectedAudioOutput(e.target.value);
              }}>
              {audioOutputs.map((device) => (
                <option key={device.deviceId} value={device.deviceId}>
                  {device.label || device.deviceId}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default AvailableResources;
